export default {
  QOS: 'QoS策略',
  AccessRuleTitle: '服务质量QoS（Quality of Service）用于网络资源的合理调配，解决网络延迟和阻塞等问题。通过设置QoS策略，可以帮助您区分不同应用和不同业务的流量，保证关键业务流量的带宽，提高您网络资源的利用率，保证网络的质量。', // qos的访问规则的标题
  AccessRuleDesc: 'QoS策略目前仅支持出方向的限速，暂不支持入方向的限速，请知悉。', // qos的访问规则的描述
  MinMaxBandwidth: '最小/最大带宽',
  RelatedTitle: '系统通过流量分类规则，划分流量。根据限速规则优先级，优先保证关联高优先级限速规则的流量带宽。相同网关下，策略的流量分类信息不能重叠，以免影响策略生效，请知悉。注意：若设置的最大带宽超过关联网关的采购带宽，实际生效将以关联网关的采购带宽作为最大带宽。', // qos的已关联网关的标题
  SpecialNote: '特别提示：批量操作仅用于新增关联关系，访问规则原绑定的网关关系将保留，不会被修改。如有需要，可前往',
  QosPlotRelatedNet: 'QoS策略-已关联网关',
  ToManage: '下进行管理。', // SpecialNote和QosPlotRelatedNet和ToManage本为一句话由于有可点击链接，所以拆分
  BatchDeleteQos: '批量删除策略',
  AreYouSureDeleteQos: '您确定要批量删除这些策略吗?',
  LimitBandwidth: '限速带宽',
  NotSetLimitRule: '该优先级还未配置过限速规则，请先配置',
  ToSet: '去配置',
  LimitPriority: '限速优先级',
  ConfigPlot: '配置策略',
  ChangeTime: '最近修改时间',
  PlotName: '策略名称',
  SearchPlotName: '搜索策略名',
  RemoveRelatedQos: '移除已选择的策略，将与当前网关解绑。网关实例通过匹配规则过滤流量。未关联网关则规则不会生效。添加策略只支持当前账号创建的策略。',
  SelectAddQos: '选择添加策略',
  RelationQosMore: (val: number) => `网关关联的策略数超过${val}条，请修改后重试`,
  ConfigedPlot: '已配置策略',
  DefaultLimitConfig: '默认限速配置',
  AllGatewayMoreThan: (gatewayNames: string) => `网关 ${gatewayNames} 关联的策略数量已达上限,请重新选择网关`,
}